module.exports = __webpack_public_path__ + "img/futuro.2c64e82d.svg";